module.exports = __webpack_public_path__ + "static/media/32.d246ad5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/32.png
// module id = 400
// module chunks = 0